import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';

export interface CityHubFaqItem { question: string; answer: string; }
export interface CityHubBreadcrumbItem { name: string; url: string; }

export interface CityHubData {
  state: string;
  city: string;
  cityDisplay: string;
  stateDisplay: string;
  stateAbbr: string | null;
  totalCount: number;
  jobs: any[];
  locationInfo: any | null;
  siblingCities: string[];
  introBlurb: string;
  faq: CityHubFaqItem[];
  breadcrumb: CityHubBreadcrumbItem[];
}

@Injectable({ providedIn: 'root' })
export class CityHubService {
  private _route = '/api/city-hub';

  constructor(private httpClient: HttpClient) { }

  get(state: string, city: string): Observable<CityHubData> {
    return this.httpClient.get<CityHubData>(`${this._route}/${encodeURIComponent(state)}/${encodeURIComponent(city)}`);
  }
}
